module.exports = __webpack_public_path__ + "static/media/asitestimonials.fef44614.png";